define('app/sf/groups/of/sf-groups-of-filter',[],function () {
	return function sfGroupsOfFilter(input, groupLength) {
		if (!angular.isObject(input)) {
			return input;
		}
		var result = [];
		var current;
		var i = 0;
		angular.forEach(input, function (value, key) {
			if (i >= groupLength) {
				result.push(current);
				current = undefined;
				i = 0;
			}
			(current = current || {})[key] = value;
			i++;
		});
		if (current) {
			result.push(current);
		}
		return result;
	};
});
